import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=0feba302&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=js&"
export * from "./AppForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feba302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0feba302')) {
      api.createRecord('0feba302', component.options)
    } else {
      api.reload('0feba302', component.options)
    }
    module.hot.accept("./AppForm.vue?vue&type=template&id=0feba302&scoped=true&", function () {
      api.rerender('0feba302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/event/modules/AppForm.vue"
export default component.exports